import { ItemModel } from "@syncfusion/ej2-angular-splitbuttons";

// font family

export const fontFamily: Object = {
  default: "Arial",
  items: [
    {
      text: "Arial",
      value: "Arial, Helvetica, sans-serif",
      cssClass: "e-arial",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Times New Roman",
      value: "Times New Roman,Times,serif",
      cssClass: "e-times-new-roman",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Helvetica",
      value: "Helvetica",
      cssClass: "e-helvetica",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Calibri",
      value: "Calibri, Helvetica, sans-serif",
      cssClass: "e-calibri",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Verdana",
      value: "Verdana,Geneva,sans-serif",
      cssClass: "e-verdana",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Georgia",
      value: "Georgia,serif",
      cssClass: "e-georgia",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Open Sans",
      value: "Open Sans, sans-serif",
      cssClass: "e-open-sans",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Roboto",
      value: "Roboto",
      cssClass: "e-roboto",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Lato",
      value: "Lato, sans-serif",
      cssClass: "e-lato",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Montserrat",
      value: "Montserrat, sans-serif",
      cssClass: "e-montserrat",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Segoe UI",
      value: "Segoe UI",
      cssClass: "e-segoe-ui",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "Impact",
      value: "Impact,Charcoal,sans-serif",
      cssClass: "e-impact",
      command: "Font",
      subCommand: "FontName",
    },
    // New fonts
    {
      text: "Tiempos Headline - Semibold",
      value: "Tiempos Headline Semibold",
      cssClass: "e-tiempos-headline",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "微软雅黑",
      value: "Microsoft YaHei,微软雅黑,SimHei, sans-serif",
      cssClass: "e-yahei",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "等线",
      value: "DengXian,等线,sans-serif",
      cssClass: "e-dengxian",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "思源黑体",
      value: "Source Han Sans CN, Microsoft YaHei,'微软雅黑', sans-serif",
      cssClass: "e-source-han-sans-cn-regular",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "思源宋体",
      value: "Source Han Serif CN, SimSun,'宋体',serif",
      cssClass: "e-source-han-serif-cn-regular",
      command: "Font",
      subCommand: "FontName",
    },
    {
      text: "霞鹜文楷",
      value:
        "LXGW WenKai,'霞鹜文楷',STKaiti, KaiTi, '楷体', '华文楷体', Arial, sans-serif",
      cssClass: "e-lxgw",
      command: "Font",
      subCommand: "FontName",
    },
    // Ping Fang SC 系列
    {
      text: "Ping Fang SC - Light",
      value: "苹方-简",
      cssClass: "e-ping-fang-sc-light",
      command: "Font",
      subCommand: "FontName",
    },
  ],
};

export const size = {
  default: "11pt",
  width: "40px",
  items: [
    { text: "8 pt", value: "8pt" },
    { text: "9 pt", value: "9pt" },
    { text: "10 pt", value: "10pt" },
    { text: "11 pt", value: "11pt" },
    { text: "12 pt", value: "12pt" },
    { text: "14 pt", value: "14pt" },
    { text: "18 pt", value: "18pt" },
    { text: "24 pt", value: "24pt" },
    { text: "36 pt", value: "36pt" },
  ],
};

// line height配置
export const lineHeight_items: ItemModel[] = [
  {
    text: "1.0",
  },
  {
    text: "1.15",
  },
  {
    text: "1.5",
  },
  {
    text: "2.0",
  },
  {
    text: "2.5",
  },
  {
    text: "3.0",
  },
];

// 无序列表符号配置
export interface BulletStyle {
  id: string;
  text: string;
  symbol: string;
  iconCss: string;
  description: string;
}

export const BULLET_STYLES: BulletStyle[] = [
  {
    id: "disc",
    text: "● 实心圆点",
    symbol: "●",
    iconCss: "e-icons e-bullet-disc",
    description: "标准实心圆点",
  },
  {
    id: "circle",
    text: "○ 空心圆点",
    symbol: "○",
    iconCss: "e-icons e-bullet-circle",
    description: "空心圆点",
  },
  {
    id: "square",
    text: "■ 实心方块",
    symbol: "■",
    iconCss: "e-icons e-bullet-square",
    description: "实心方块",
  },
  {
    id: "diamond",
    text: "◆ 实心菱形",
    symbol: "◆",
    iconCss: "e-icons e-bullet-diamond",
    description: "实心菱形",
  },
  {
    id: "triangle",
    text: "► 实心三角",
    symbol: "►",
    iconCss: "e-icons e-bullet-triangle",
    description: "实心三角形",
  },
  {
    id: "arrow",
    text: "➤ 箭头",
    symbol: "➤",
    iconCss: "e-icons e-bullet-arrow",
    description: "箭头符号",
  },
  {
    id: "star",
    text: "★ 星形",
    symbol: "★",
    iconCss: "e-icons e-bullet-star",
    description: "星形符号",
  },
  {
    id: "check",
    text: "✓ 对勾",
    symbol: "✓",
    iconCss: "e-icons e-bullet-check",
    description: "对勾符号",
  },
  {
    id: "heart",
    text: "♥ 心形",
    symbol: "♥",
    iconCss: "e-icons e-bullet-heart",
    description: "心形符号",
  },
  {
    id: "bullet",
    text: "• 小圆点",
    symbol: "•",
    iconCss: "e-icons e-bullet-bullet",
    description: "小圆点",
  },
];

// 获取符号样式
export function getBulletStyle(id: string): BulletStyle | undefined {
  return BULLET_STYLES.find((style) => style.id === id);
}

// 获取所有符号样式
export function getAllBulletStyles(): BulletStyle[] {
  return BULLET_STYLES;
}

// 应用符号样式到列表
export function applyBulletStyle(ul: HTMLElement, style: BulletStyle): void {
  if (style.id === "disc" || style.id === "circle" || style.id === "square") {
    // 使用CSS list-style-type
    ul.style.listStyleType = style.id;
    // 移除自定义符号
    ul.querySelectorAll(".custom-bullet").forEach((bullet) => bullet.remove());
  } else {
    // 使用自定义符号
    ul.style.listStyleType = "none";
    ul.setAttribute("data-bullet-style", style.id);

    const listItems = ul.querySelectorAll("li");
    listItems.forEach((li) => {
      // 移除现有的自定义符号
      const existingBullet = li.querySelector(".custom-bullet");
      if (existingBullet) {
        existingBullet.remove();
      }

      // 添加新的自定义符号
      const bullet = document.createElement("span");
      bullet.className = "custom-bullet";
      bullet.textContent = style.symbol;
      bullet.style.marginRight = "8px";
      bullet.style.color = "#666";

      // 将符号插入到列表项的开头
      li.insertBefore(bullet, li.firstChild);
    });
  }
}
